import type { InternalDropdownOption } from '~/chords/DropdownSingleSelect/types';

interface UpdateSelectedOptionsParams {
  prevSelectedOptionIndex?: number;
  newSelectedOptionIndex: number;
}

/**
 * Update the options in the dropdown based on the selected option.
 * @param prevOptions - The previous options in the dropdown.
 * @param param1.prevSelectedOptionIndex - The previously selected option's index, if any.
 * @param param1.newSelectedOptionIndex - The newly selected option's index.
 * @returns The updated options.
 */
export function updateSelectedOptions(
  prevOptions: InternalDropdownOption[],
  {
    prevSelectedOptionIndex,
    newSelectedOptionIndex,
  }: UpdateSelectedOptionsParams,
) {
  const newOptions = structuredClone(prevOptions);

  // Set isSelected=false for the previously selected option.
  if (prevSelectedOptionIndex !== undefined) {
    newOptions[prevSelectedOptionIndex].isSelected = false;
  }

  // Set isSelected=true for the newly selected option.
  newOptions[newSelectedOptionIndex].isSelected = true;

  return newOptions;
}
